<div class="ui-g">
  <div class="ui-g-4">
    <div>
      <strong>
        {{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}
      </strong>
    </div>
    <span id="beneficiaries_total">
      {{ beneficiariesTotal }}
    </span>
  </div>
</div>

<div *ngFor="let type of beneficiaryTypes$ | async">
  <h4 class="primary-color">{{ type }}</h4>
  <div *ngFor="let beneficiary of census?.beneficiaries | beneficiaryType:type">
    <div class="ui-g" *ngIf="beneficiary.beneficiaryCategoryData?.active">
      <div class="ui-g-8">
        <strong>
          {{ beneficiary.beneficiaryCategoryData?.beneficiaryCategoryCategory }}
        </strong>
      </div>
      <div class="ui-g-4">
        <div class="ui-inputgroup">
          <input
            [(ngModel)]="beneficiary.total"
            [disabled]="readOnly"
            pInputText
            type="number"
            wsdPositiveNumbersOnly>
          <span
            class="ui-inputgroup-addon primary-color right"
            pTooltip="{{ beneficiary.beneficiaryCategoryData?.beneficiaryCategoryDescription || 'All non-classifiable beneficiaries' }}"
            tooltipPosition="left">
          <i class="fa fa-info-circle"></i>
        </span>
        </div>
      </div>
    </div>
  </div>
</div>
